import { Component, OnInit } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { Router, ActivatedRoute } from '@angular/router';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ContactService } from './../../services/contact.service';
import { SoaImageService } from './../../services/soa-image.service';
import { DatePipe } from '@angular/common';
import { EncrDecrService } from './../../services/encr-decr.service';
declare var $: any;

@Component({
  selector: 'app-add-mobile',
  templateUrl: './add-mobile.component.html',
  styleUrls: ['./add-mobile.component.css']
})


export class AddMobileComponent implements OnInit {
  foldermode: any = '';
  custname: any = '';
  submitted = false;
  btnDisable: boolean = false;
  user_id: any = '';
  company_id: any = '';
  APIKEY: any = '';
  currentUserRole: any = '';
  customerList: object = [];
  model: any = { reference_number: '', po_number: '', work_week: '', load_number: '', mobile_invoice_number: '' };

  validFolderError: boolean = false;
  validFolder: boolean = false;

  existingCustomer: boolean = false;
  manuallyCustomer: boolean = false;
  id_encrypt: any;
  id_enc: any;
  maxDate: Date;

  constructor(private _router: Router, private _contact: ContactService,
    private _soaImage: SoaImageService,
    private EncrDecr: EncrDecrService,
    private toastr: ToastrService, private _activatedroute: ActivatedRoute, private datePipe: DatePipe,) { }

  ngOnInit() {
    this.maxDate = new Date();
    this.user_id = localStorage.getItem('id');
    this.company_id = localStorage.getItem('company_id');
    this.APIKEY = localStorage.getItem('APIKEY');
    this.currentUserRole = localStorage.getItem('role_name');

    //get customer for mobile and other role user
    const customerModal = {
      APIKEY: this.APIKEY,
      user_id: this.user_id,
      company_id: this.company_id,
      status: 'active',
    }

    this._contact.getAssignContactListByid(customerModal)
      .subscribe(
        res => {

          this.customerList = res;
        },
      );
    //// end

    $(function () {
      $(".select2").select2({
        placeholder: "--Select--"
      });
    });

    this._activatedroute.params.subscribe(params => {
      this.foldermode = params['mode'];
      this.custname = this.EncrDecr.get(localStorage.getItem('key'), params['id']);

      if (this.foldermode == 'existing') {
        this.existingCustomer = true;
        this.manuallyCustomer = false;
      }
      else {
        this.existingCustomer = false;
        this.manuallyCustomer = true;
      }
      this.model['customer'] = this.custname;
    });

  }

  onSubmitMFolder() {
    this.model['APIKEY'] = this.APIKEY;
    this.model['user_id'] = this.user_id;
    this.model['company_id'] = this.company_id;
    this.model['customer'] = $(".select2").val();
    // this.model['date_invoice']= this.datePipe.transform(this.model['date_invoice'], 'MM/dd/yyyy, hh:mm a');
    if (this.model['reference_number'] == ''
      && this.model['po_number'] == ''
      && this.model['work_week'] == ''
      && this.model['load_number'] == '' && this.model['mobile_invoice_number'] == '') {
      this.validFolderError = true;
      this.validFolder = true;
      return false;
    }
    else {
      this.btnDisable = true;
      this.validFolderError = false;
      this.validFolder = false;
      this.model['work_week'] = this.datePipe.transform(this.model['work_week'], 'MM/dd/yyyy, hh:mm a');
    }

    this._soaImage.saveMobileFOlder(this.model)
      .subscribe(
        res => {
          this.id_enc = this.EncrDecr.set(localStorage.getItem('key'), res.id);
          this._router.navigateByUrl('/mobile/edit-mobile/' + this.id_enc);
        },
      );
  }

  check_req_field($event) {
    if ($event.target.value != '') {
      this.validFolderError = false;
    }
  }

  omit_special_char(event) {
    var k;
    k = event.charCode;
    return ((k > 64 && k < 91) || (k > 96 && k < 123) || k == 8 || (k == 32 && k == 45) || (k >= 48 && k <= 57));
  }


}
